import axios from 'axios';

export class ConfigurationService {
  static async load() {
    return new ConfigurationService().load();
  }

  constructor() {
    this.configuration = {};
  }

  async load() {
    const response = await axios.get(`assets/configurations/env.json`);
    this.configuration = response.data;
    return this.configuration;
  }

  getOperationConfiguration(operation) {
    return this.configuration.operations[operation];
  }
  
}
